import { lazy } from "react";

const UsersRoutes = [
  {
    path: "/merchants",
    component: lazy(() => import("../../views/users/Users")),
  },
  {
    path: "/users/customers",
    component: lazy(() => import("../../views/users/Customers")),
  },
  //   {
  //     path: "/demo/modal",
  //     component: lazy(() => import("../../views/demo/Modal")),
  //   },
];

export default UsersRoutes;
